/// <reference path="./scanf.d.ts" />
const { scanf, sscanf } = require('./scanf')
export { scanf, sscanf } 